module.exports = __webpack_public_path__ + "img/stream.2cf925c9.png";